import React from 'react'
import { Tooltip } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import ResultButton from './ResultButton'

const GoToCohortDashboard = ({ cohortId, analysisType }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(`/libra/cohort/${cohortId}`, { state: { analysisType } })
  }

  return (
    <Tooltip title="Open cohort dashboard" arrow>
      <ResultButton primary onClick={handleClick}>
        Cohort
      </ResultButton>
    </Tooltip>
  )
}

export default GoToCohortDashboard
